import React from 'react'
import { Button } from '@chakra-ui/react'

const ButtonCTA = ({ children, ...rest }) => {
  return <Button {...rest}>{children}</Button>
}

export default ButtonCTA
